import { Box, Paper, Divider, IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import DownloadIcon from "@mui/icons-material/Download";

import SmallInput from "../Inputs/SmallInput";
import SmallSelect from "../Inputs/SmallSelect";
import SmallDateInput from "../Inputs/SmallDateInput";

type OrderStatus =
  | ""
  | "cancelled"
  | "created"
  | "confirmed"
  | "in_transit"
  | "ending"
  | "delivered"
  ;

// Mapea los estados de status_type a etiquetas
const STATUS_OPTIONS = [
  { value: "", label: "Todos" },
  { value: "cancelled", label: "Cancelado" },
  { value: "created", label: "Creado" },
  { value: "confirmed", label: "Confirmado" },
  { value: "in_transit", label: "En transito" },
  { value: "ending", label: "En ruta final" },
  { value: "delivered", label: "Entregado" }
  
];

export default function ReservationFilters({
  search,
  setSearch,
  community,
  setCommunity,
  status,
  setStatus,
  from,
  setFrom,
  to,
  setTo,
  communities,
  onReset,
  onExport
}: {
  search: string;
  setSearch: (v: string) => void;
  community: string;
  setCommunity: (v: string) => void;
  status: OrderStatus; // ✅ cambiar aquí
  setStatus: (v: OrderStatus) => void; // ✅ cambiar aquí
  from: string;
  setFrom: (v: string) => void;
  to: string;
  setTo: (v: string) => void;
  communities: string[];
  onReset: () => void;
  onExport: () => void;
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: "1px solid #eee",
        borderRadius: 3,
        px: 2,
        py: 1.5,
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
        
        {/* 🔍 Buscar */}
        <Box sx={{ width: 220 }}>
          <SmallInput
            placeholder="Buscar"
            value={search}
            onChange={(e: any) => setSearch(e.target.value)}
          />
        </Box>

        {/* <Divider orientation="vertical" flexItem />

        <Box sx={{ width: 200 }}>
          <SmallSelect
            value={community}
            onChange={(e: any) => setCommunity(e.target.value)}
            options={[
              { value: "", label: "Todos los conductores" },
              ...communities.map((c) => ({
                value: c,
                label: c,
              })),
            ]}
          />
        </Box> */}

        <Divider orientation="vertical" flexItem />

        {/* Desde */}
        <Box sx={{ width: 140 }}>
          <SmallDateInput
            label="Desde"
            value={from}
            onChange={(e: any) => setFrom(e.target.value)}
          />
        </Box>

        {/* Hasta */}
        <Box sx={{ width: 140 }}>
          <SmallDateInput
            label="Hasta"
            value={to}
            onChange={(e: any) => setTo(e.target.value)}
          />
        </Box>

        <Divider orientation="vertical" flexItem />

        {/* Estado dinámico */}
        <Box sx={{ width: 160 }}>
          <SmallSelect
            placeholder={'Todos los estados'}
            value={status}
            onChange={(e: any) => setStatus(e.target.value as OrderStatus)}
            options={STATUS_OPTIONS}
          />
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        {/* Reset */}
        
        <IconButton
          size="small"
          onClick={onExport}
          sx={{
            border: "1px solid #eee",
            borderRadius: 2,
            height: 38,
            width: 38,
          }}
        >
          <DownloadIcon fontSize="small" />
        </IconButton>

        <IconButton
          size="small"
          onClick={onReset}
          sx={{
            border: "1px solid #eee",
            borderRadius: 2,
            height: 38,
            width: 38,
          }}
        >
          <RefreshIcon fontSize="small" />
        </IconButton>
      </Box>
    </Paper>
  );
}
